module.exports = __webpack_public_path__ + "static/img/ordertrack_style.5af61eba.png";